export enum SettingsTabEnum {
  general = 'general',
  forecast = 'meteo',
  newsletters = 'newsletters',
}
